import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

import KeysListItem from './components/KeysListItem';
import InputSection from './components/InputSection';

import styles from './Keys.module.css';
import Title from '../../common/components/Title';
import {Permission} from "../../components/SessionInfo";
import {hetch} from "../../utils/fetch.hooked";

function Keys({ permission }) {
  const [keysList, setKeysList] = useState(null);

  const handleEditComplete = (id, currentName) => {
    setKeysList(keysList.map((item) => {
      if (item.id === id) {
        item.key_name = currentName;
      }

      return item;
    }));
  };

  const addItem = (id, key_name) => {
    setKeysList([...keysList, { id, key_name }]);
  }

  const handleRemoveItem = (id) => {
    setKeysList(keysList.filter(item => item.id !== id));
  }

  useEffect(() => {
    const fetchData = () => {
      hetch('/api/key_names')
        .then(res => res.json())
        .then(res => {
          setKeysList(res?.content ?? []);
        });
    }

    fetchData();
  }, []);

  return (
    <div className={styles.container}>
      <Title title="Список имён УКЭП и сертификатов"/>
      {keysList ? (
        <Box>
          {keysList.length
            ? <div className={styles.list}>
                {keysList.map(item => (
                  <KeysListItem
                    key={item.id}
                    id={item.id}
                    name={item.key_name}
                    handleEditComplete={handleEditComplete}
                    handleRemoveItem={handleRemoveItem}
                    permission={permission}
                  />
                ))}
              </div>
            : <Alert severity="warning" sx={{mb: 2}}>Сертификаты не найдены</Alert>
          }
          {permission===Permission.WRITE ? <InputSection addItem={addItem} /> : null }
        </Box>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      )}
    </div>
  )
}

export default Keys;
